import { APIService } from "@/common/api.service";
import {
  GET_OPEN_SEATS_BY_JOB_ROLE,
  GET_AVAILABLE_RESOURCES,
  GET_ACTIVE_USERS,
  GET_OPEN_SEATS_BY_PROJECT,
  GET_RESOURCES_OVER_TIME,
  GET_ACTIVE_PROJECTS,
  GET_AVAILABLE_PROJECTS,
  GET_ACTIVE_OPEN_SEATS,
  GET_AVAILABLE_OPEN_SEATS,
  GET_RESOURCES_BY_BAND,
  GET_PERSON_PRACTICE_CHART,
  GET_OPEN_SEATS_OVER_TIME,
  GET_OPEN_SEATS_BY_ACCOUNT,
  GET_PERSON_ACCOUNT_CHART,
} from "./actions.type";
import {
  SET_OPEN_SEATS_BY_JOB_ROLE,
  SET_AVAILABLE_USERS,
  SET_ACTIVE_USERS,
  SET_OPEN_SEATS_BY_PROJECT,
  SET_RESOURCES_OVER_TIME,
  SET_ACTIVE_PROJECTS,
  SET_AVAILABLE_PROJECTS,
  SET_ACTIVE_OPEN_SEATS,
  SET_AVAILABLE_OPEN_SEATS,
  SET_RESOURCES_BY_BAND,
  SET_PERSON_PRACTICE_CHART,
  SET_OPEN_SEAT_OVER_TIME,
  SET_OPEN_SEATS_BY_ACCOUNT,
  SET_PERSON_ACCOUNT_CHART,
} from "./mutations.type";

const state = {
  openSeatsByJobRole: [],
  availableResources: [],
  activeUsers: {},
  openSeatsByProject: [],
  resourcesOverTime: [],
  activeProjects: [],
  availableProjects: [],
  activeOpenSeats: [],
  availableOpenSeats: [],
  personAccountChart: [],
  resourcesByBand: [],
  openSeatsOverTime: [],
  personPracticeChart: [],
  openSeatsByAccountChart: [],
};
const getters = {
  openSeatsByJobRole(state) {
    return state.openSeatsByJobRole;
  },
  availableResources(state) {
    return state.availableResources;
  },
  activeUsers(state) {
    return state.activeUsers;
  },
  openSeatsByProject(state) {
    return state.openSeatsByProject;
  },
  resourcesOverTime(state) {
    return state.resourcesOverTime;
  },
  activeProjects(state) {
    return state.activeProjects;
  },
  availableProjects(state) {
    return state.availableProjects;
  },
  activeOpenSeats(state) {
    return state.activeOpenSeats;
  },
  availableOpenSeats(state) {
    return state.availableOpenSeats;
  },
  openSeatsOverTime(state) {
    return state.openSeatsOverTime;
  },
  openSeatsByAccountChart(state) {
    return state.openSeatsByAccountChart;
  },
  personPracticeChart(state) {
    return state.personPracticeChart;
  },
  personAccountChart(state) {
    return state.personAccountChart;
  },
  resourcesByBand(state) {
    return state.resourcesByBand;
  },
};

const actions = {
  async [GET_OPEN_SEATS_BY_JOB_ROLE](context, accountParam) {
    try {
      const { data } = await APIService.query(
        "/insights/open-seats-by-job-role",
        accountParam
      );
      context.commit(SET_OPEN_SEATS_BY_JOB_ROLE, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_AVAILABLE_RESOURCES](context, accountParam) {
    try {
      const { data } = await APIService.query(
        "/insights/available-resources",
        accountParam
      );
      context.commit(SET_AVAILABLE_USERS, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_ACTIVE_USERS](context, accountParam) {
    try {
      const { data } = await APIService.query(
        "/insights/active-users",
        accountParam
      );
      context.commit(SET_ACTIVE_USERS, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_OPEN_SEATS_BY_PROJECT](context, accountParam) {
    try {
      const { data } = await APIService.query(
        "/insights/open-seats-by-project",
        accountParam
      );
      context.commit(SET_OPEN_SEATS_BY_PROJECT, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_RESOURCES_OVER_TIME](context, filter) {
    try {
      const { data } = await APIService.query(
        "/insights/resources-over-time",
        filter
      );
      context.commit(SET_RESOURCES_OVER_TIME, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_ACTIVE_PROJECTS](context, filter) {
    try {
      const { data } = await APIService.query(
        "/insights/active-projects",
        filter
      );
      context.commit(SET_ACTIVE_PROJECTS, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_AVAILABLE_PROJECTS](context, accountParam) {
    try {
      const { data } = await APIService.query(
        "/insights/available-projects",
        accountParam
      );
      context.commit(SET_AVAILABLE_PROJECTS, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_ACTIVE_OPEN_SEATS](context, filter) {
    try {
      const { data } = await APIService.query(
        "/insights/active-open-seats",
        filter
      );
      context.commit(SET_ACTIVE_OPEN_SEATS, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_AVAILABLE_OPEN_SEATS](context, accountParam) {
    try {
      const { data } = await APIService.query(
        "/insights/available-open-seats",
        accountParam
      );
      context.commit(SET_AVAILABLE_OPEN_SEATS, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_PERSON_PRACTICE_CHART](context, filter) {
    try {
      const { data } = await APIService.query(
        "/insights/person-practice-bargraph",
        filter
      );
      context.commit(SET_PERSON_PRACTICE_CHART, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_PERSON_ACCOUNT_CHART](context, filter) {
    try {
      const { data } = await APIService.query(
        "insights/person-account-piechart",
        filter
      );
      context.commit(SET_PERSON_ACCOUNT_CHART, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_RESOURCES_BY_BAND](context, filter) {
    try {
      const { data } = await APIService.query(
        "insights/person-band-piechart",
        filter
      );

      context.commit(SET_RESOURCES_BY_BAND, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_OPEN_SEATS_OVER_TIME](context, accountParam) {
    try {
      const { data } = await APIService.query(
        "/insights/open-seats-over-time",
        accountParam
      );
      context.commit(SET_OPEN_SEAT_OVER_TIME, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_OPEN_SEATS_BY_ACCOUNT](context, accountParam) {
    try {
      const { data } = await APIService.query(
        "/insights/open-seats-by-account",
        accountParam
      );
      context.commit(SET_OPEN_SEATS_BY_ACCOUNT, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
};

const mutations = {
  [SET_OPEN_SEATS_BY_JOB_ROLE](state, openSeatsByJobRole) {
    state.openSeatsByJobRole = openSeatsByJobRole;
  },
  [SET_AVAILABLE_USERS](state, availableResources) {
    state.availableResources = availableResources;
  },
  [SET_ACTIVE_USERS](state, activeUsers) {
    state.activeUsers = activeUsers;
  },
  [SET_OPEN_SEATS_BY_PROJECT](state, openSeatsByProject) {
    state.openSeatsByProject = openSeatsByProject;
  },
  [SET_RESOURCES_OVER_TIME](state, resourcesOverTime) {
    state.resourcesOverTime = resourcesOverTime;
  },
  [SET_ACTIVE_PROJECTS](state, activeProjects) {
    state.activeProjects = activeProjects;
  },
  [SET_AVAILABLE_PROJECTS](state, availableProjects) {
    state.availableProjects = availableProjects;
  },
  [SET_ACTIVE_OPEN_SEATS](state, activeOpenSeats) {
    state.activeOpenSeats = activeOpenSeats;
  },
  [SET_AVAILABLE_OPEN_SEATS](state, availableOpenSeats) {
    state.availableOpenSeats = availableOpenSeats;
  },
  [SET_OPEN_SEATS_BY_ACCOUNT](state, openSeatsByAccountChart) {
    state.openSeatsByAccountChart = openSeatsByAccountChart;
  },
  [SET_PERSON_ACCOUNT_CHART](state, personAccountChart) {
    state.personAccountChart = personAccountChart;
  },
  [SET_RESOURCES_BY_BAND](state, resourcesByBand) {
    state.resourcesByBand = resourcesByBand;
  },
  [SET_PERSON_PRACTICE_CHART](state, personPracticeChart) {
    state.personPracticeChart = personPracticeChart;
  },
  [SET_OPEN_SEAT_OVER_TIME](state, openSeatsOverTime) {
    state.openSeatsOverTime = openSeatsOverTime;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
